import {data_stahltreppen} from '../../../assets/images/stahltreppen/data_stahltreppen';

const initialeStates = {
    data: data_stahltreppen
}

const stahltreppenReducer = (states = initialeStates, action) => {
    const copyOfState = {...states};

    switch (action.type) {

        //update modell
        case 'UPDATEMODELLSTAHLTREPPE':
            let modell_index = action.ev.index;
            let modell_img = action.ev.img;
            let modell_titel = action.ev.titel;

            copyOfState.data.modell[0].index = modell_index;
            copyOfState.data.modell[0].img = modell_img;
            copyOfState.data.modell[0].titel = modell_titel;
        return copyOfState;

        //update muster
        case 'UPDATEMUSTERSTAHLTREPPE':
            let muster = action.ev;
            copyOfState.data.modell[0].muster = muster;
        return copyOfState;

        //update type geländer
        case 'UPDATEGELAENDERTYPESTAHLGELAENDER':
            let gelaender_type_index = action.ev.index;
            let gelaender_type = action.ev.titel;
            let product_image = action.ev.image;
            copyOfState.data.gelaender[0].gelaender_index = gelaender_type_index;
            copyOfState.data.gelaender[0].gelaender_type = gelaender_type;
            copyOfState.data.gelaender[0].img = product_image;
        return copyOfState;

        //update steps
        case 'UPDATESTEPSSTAHLTREPPE':
            let step_index = action.ev;
            let steps = copyOfState.data.steps[0];
            let visited_steps = copyOfState.data.steps[1].visited;
            let step_icons = document.querySelectorAll(".MuiStepIcon-root");

            copyOfState.data.steps[0][step_index] = true;
            copyOfState.data.steps[1].visited[step_index] = step_index;

            steps.forEach((elem, index) => {
                 if(elem === true) {
                    step_icons[index].classList.add('MuiStepIcon-active');
                 } else {
                    step_icons[index].classList.remove('MuiStepIcon-active');
                 }
            })

            copyOfState.data.steps[1].active_steps = visited_steps;
        return copyOfState;

        //update all visited steps
        case 'UPDATEALLVISITEDSTEPSSTAHLTREPPE':
            copyOfState.data.allVisitedSteps = true;
        return copyOfState;

         //update handlauf form
         case 'UPDATEHANDLAUFFORMSTAHLTREPPEN':
            let handlauf_form_titel = action.ev;
            copyOfState.data.handlauf[0].handlauf_form = handlauf_form_titel;
        return copyOfState;

        //update handrail endkappe
        case 'UPDATEHANDLAUFENDKAPPESTAHLTREPPEN':
            let handlauf_endkappe_titel = action.ev.titel;
            let handlauf_endkappe_index = action.ev.index;
            copyOfState.data.handlauf[0].endkappe = handlauf_endkappe_titel;
            copyOfState.data.handlauf[0].endkappe_index = handlauf_endkappe_index;
        return copyOfState;

        //update height
        case 'SELECTSTAHLTREPPENHEIGHT':
            let height = action.ev;
            let stufen = 0;

            //if (height>=83) stufen = Math.round(height/17);
            stufen = Math.round(height/17);
            copyOfState.data.geschosshoehe[0].height = height;
            copyOfState.data.geschosshoehe[0].stufen = stufen;
        return copyOfState;

        //update stufenbreite
        case 'SELECTSTUFENBREITE':
            let stufenBreite = action.ev;
            copyOfState.data.stufenBreite = stufenBreite;
        return copyOfState;

        //update podest
        case 'UPDATEPODEST':
            let is_podest = action.ev;
            copyOfState.data.podest[0].isPodest = is_podest;
        return copyOfState;

        //update podest width
        case 'UPDATEPODESTWIDTH':
            let podest_width = action.ev;
            copyOfState.data.podest[0].podestWidth = podest_width;
        return copyOfState;

        //update kind of color
        case 'SELECTKINDOFCOLORSTAHLTREPPEN':
            let kind_of_color = action.ev;
            copyOfState.data.colors[0].kind_of_color = kind_of_color;
        return copyOfState;

        //update color
        case 'SELECTCOLORSTAHLTREPPEN':
            let color = action.ev.color;
            let color_index = action.ev.index;
            copyOfState.data.colors[0].color_index = color_index;
            copyOfState.data.colors[0].color = color;
            copyOfState.data.colors[0].wish_color = '';
        return copyOfState;

        //update wish color
        case 'SELECTWISHCOLORSTAHLTREPPEN':
            let wish_color = action.ev;
            copyOfState.data.colors[0].wish_color = wish_color;
        return copyOfState;

        //select upload file
        case 'SELECTUPLOADDATASTAHLTREPPEN':
            const fileSize = action.ev.file.size;
            const bytesToMegaBytes = fileSize / (1024 ** 2);
            if (bytesToMegaBytes>5) {
                copyOfState.data.data_description[0].isUploadData = false;
            } else {
                let data_file = action.ev.file;
                copyOfState.data.data_description[0].file = data_file;
                copyOfState.data.data_description[0].isUploadData = true;
            }
        return copyOfState;

        //update description
        case 'UPDATEDESCRIPTIONSTAHLTREPPEN':
            let description = action.ev;
            copyOfState.data.data_description[0].description = description;
        return copyOfState;

        //update products to merkliste
        case 'UPDATEPRODUCTTOPMERKLISTESTAHLTREPPE':
            copyOfState.data.is_merkliste = !copyOfState.data.is_merkliste;
        return copyOfState;

        case 'UPDATEEDITSTAHLTREPPE':
            copyOfState.data.isEdit = !copyOfState.data.isEdit;
        return copyOfState;

        default:
            return copyOfState;
    }
}

export default stahltreppenReducer;